"use client";

// src/components/atoms/Icons/Icon.tsx
import { icons } from "@stone-payments/odin-icons";
import { jsx } from "react/jsx-runtime";
var Icon = ({ name, className }) => {
  const SvgIcon = icons[name];
  return /* @__PURE__ */ jsx(SvgIcon, { className });
};
var Icon_default = Icon;

export {
  Icon_default
};
